import React, { useState } from "react";
import Accordion from "../layout/Accordion";

const Faq = () => {
  const [active, setActive] = useState("");

  return (
    <section className="section-p">
      <div className="page-width">
        <div className="faq__accordion_head">
          <h1 className="text-jost-sb-50-wt">Browse our FAQs</h1>
          <p className="text-ops-rg-16-wt">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin eu
            mattis velit. Donec dictum leo vel fermentum placerat. Nullam
            bibendum blandit. Praesent eu consequat dictum leo vel. Aenean
            consectetur sit amet sem non maximus. Praesent dictum, odio non
            posuere scelerisque, diam augue sagittis arcu, vitae egestas tortor
            ligula ut arcu sit amet sem non.
          </p>
        </div>
        <div className="faq__accordion_content_wrap">
          <Accordion active={active} setActive={setActive} />
        </div>
      </div>
    </section>
  );
};

export default Faq;
